import React, { createContext, useState, useMemo, useEffect } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalDialog, setModalDialog] = useState({})
  // Configs of dialogs "paused" underneath the current one — e.g. opening
  // "Nytt företag" from inside "Ny person" pushes the person dialog's config
  // here so hideModalDialog can restore it instead of closing everything.
  const [modalStack, setModalStack] = useState([])
  const [loadingModalDialog, setLoadingModalDialog] = useState(false)
  const [show, setShow] = useState(false)

  const value = useMemo( () => (
    {
      modalDialog,
      setModalDialog,
      modalStack,
      setModalStack,
      loadingModalDialog,
      setLoadingModalDialog,
      show,
      setShow
    }
  ), [
    modalDialog,
    setModalDialog,
    modalStack,
    setModalStack,
    loadingModalDialog,
    setLoadingModalDialog,
    show,
    setShow
  ])

  return (
    <ModalContext.Provider
      value={value}
    >
      {children}
    </ModalContext.Provider>
  );
}